import { render, staticRenderFns } from "./FarmSidebarItem.vue?vue&type=template&id=0489dd24&lang=pug&"
import script from "./FarmSidebarItem.vue?vue&type=script&lang=js&"
export * from "./FarmSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports